<template>
  <div>
    <a-modal v-model="visible" :width="560" :confirmLoading="loading" :maskClosable="false" @cancel="cancel"
      @ok="confirm">
      <div slot="title">{{form.id ? '编辑股票' : '新增股票' }}</div>
      <div>
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="股票代码">
            <a-input v-model="form.name" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="form.remark" allowClear />
          </a-form-model-item>

        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { symbolsCreate, symbolsUpdate } from '@/api/symbols'
import { permissionsTree } from '@/permissions.js'
import rules from './rules.js'

export default {
  name: 'FormModal',
  props: ['visible', 'form', 'roleName'],
  model: { prop: 'visible', event: 'cancel' },
  data () {
    return {
      rules,
      loading: false,
      permissionsTree,
    };
  },
  methods: {
    confirm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let permissions = [];
          for (let value of this.form.permissions) {
            if (typeof value == "number") {
              permissions.push(value);
            }
          }

          let func = this.form.id ? symbolsUpdate : symbolsCreate;
          func({ ...this.form, permissions }).then(data => {
            if (data.code==0){
            this.$message.success(this.form.id ? '修改成功' : '新增成功');
            this.$emit(this.form.id ? 'update' : 'create', data);
            this.cancel();
            }
            else{
              this.$message.error(data.msg)
            };
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    cancel () {
      this.$emit('cancel', false);
      this.$refs.form.resetFields();
    },
    checkAll (event) {
      for (let item of this.$parent.permissionItems) {
        if (item.name == event.target.value) {
          for (let permissionItem of item.permission_items) {
            let index = this.form.permissions.indexOf(permissionItem.id);

            if (event.target.checked && index == -1) {
              this.form.permissions.push(permissionItem.id);
            } else if (!event.target.checked && index != -1) {
              this.form.permissions.splice(index, 1);
            }
          }
          break;
        }
      }
    },
  },
}
</script>

<style scoped>
</style>